import type { Domain, Site } from "@/shared/model/user/UserDomains.ts";
import { useContext } from "react";
import { AppUserInfoContext } from "@/shared/model/user/AppUserInfoContext.ts";
import { useParams } from "react-router-dom";

export interface DomainSite {
  domain?: Domain;
  site?: Site;
}

/**
 * Returns domain and site based on route parameters and user permissions.
 * If site does not belong to domain it will be undefined.
 */
export default function useDomainSiteOnRoute(): DomainSite {
  const permissions = useContext(AppUserInfoContext).permissions;
  const { domainId, siteId } = useParams();

  if (permissions === undefined) {
    return {};
  }

  const domain =
    domainId === undefined ? undefined : permissions.domain(domainId);
  return {
    domain,
    site: domain?.findSite(siteId),
  };
}
